import React from "react";
import { LayoutDashboard, GitCompareArrows, Pyramid, SquareActivity, Table2 } from "lucide-react";


export default [
  {
    title: "dashboard",
    svgIcon: <LayoutDashboard />,
    path: "/",
  },
  {
    title: "reconciliation-dashboard",
    svgIcon: <LayoutDashboard />,
    path: "/reconciliation-dashboard",
  },
  {
    title: "acquisitions",
    tinyTitle: "",

    svgIcon: <Table2 />,
    includedPaths: ["/data-acquisitions", "/data-acquisitions-instances"],
    subItems: [
      {
        title: "acquisitions-list",
        tinyTitle: "",
        path: "/data-acquisitions",
      },
      {
        title: "acquisition-instances",
        tinyTitle: "",
        path: "/data-acquisitions-instances",
      },
    ],
  },
  {
    title: "console",
    tinyTitle: "",
    svgIcon: <GitCompareArrows />,
    includedPaths: [
      "/reconciliation-streams",
      "/reconciliation-runs",
      "/business-day-information",
    ],
    subItems: [
      {
        title: "streams",
        tinyTitle: "",
        path: "/reconciliation-streams",
      },
      {
        title: "runs",
        tinyTitle: "",
        path: "/reconciliation-runs",
        includedPaths: ["/run-matching-records"],
      },
      {
        title: "businessDay",
        tinyTitle: "",
        path: "/business-day-information",
      },
    ],
  },
  {
    title: "control-room",
    tinyTitle: "",

    svgIcon: <SquareActivity />,
    includedPaths: [
      "/in-transit-summary",
      "/exception-summary",
      "/in-transit-list",
      "/in-transit-details",
      "/exception-list",
      "/exception-attempt-matching",
      "/exception-attempt-details",
    ],
    subItems: [
      {
        title: "in-transit",
        tinyTitle: "",
        path: "/in-transit-summary",
        includedPaths: ["/in-transit-list", "/in-transit-details"],
      },
      {
        title: "exception",
        tinyTitle: "",
        path: "/exception-summary",
        includedPaths: [
          "/exception-list",
          "/exception-attempt-matching",
          "/exception-attempt-details",
        ],
      },
    ],
  },

  {
    title: "tenant-hierarchy",
    tinyTitle: "",
    svgIcon: <Pyramid />,
    path: "/tenant-hierarchy",
  },
];
